import { useTranslation } from 'react-i18next';
import useSitecoreContext from './useSitecoreContext';

// use this hook for checking if we have to display the dictionary fallback
export default function useShowProductComponentTitle(hasProductTitle: boolean, dictionaryTerms: string[]): boolean {
  const {t} = useTranslation();
  const {sitecoreContext} = useSitecoreContext();
  const isPageInEditState = sitecoreContext?.pageState === 'edit';
  const hasDictionaryFallback = !!dictionaryTerms.find(x => {
    const dictionaryValue = t(x, {defaultValue: ''})?.trim();
    /**
     * in content editor if dictionary key is defined and value is not defined
     * then value returned from sitecore will be the key itself
     **/ 
    return dictionaryValue && dictionaryValue !== x;
  }
  );
  return hasProductTitle || hasDictionaryFallback || isPageInEditState;
}